import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-136" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-137" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="Garanție de satisfacție 7 zile" data-id="element-138" data-mp="222wjc7wug0nm">
          <defs data-id="element-139" data-mp="19dzbkyq9dm94">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-140" data-mp="19fsgo9l83yf0" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-141" data-mp="14hh9y7q86410" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-142" data-mp="1j650u0p4lpkm" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-143" data-mp="1ec99hh3db0yf">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-144" data-mp="lp6cwui950at">
              GARANȚIE DE SATISFACȚIE · CUMPERI FĂRĂ GRIJI ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-145" data-mp="oxozjv6m8sx7">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-146" data-mp="yqmczmwr3roy">
            ZILE
          </text>
        </svg>

        <div data-id="element-147" data-mp="62i3eqb26ugz">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-148" data-mp="630a6gvckr35">
            Garanție de satisfacție 7 zile
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-149" data-mp="f0kdrwgomzgx">
            Descarcă materialul și vezi cum funcționează la orele tale de matematică. Dacă pachetul nu
            corespunde așteptărilor tale, ne poți scrie pe e-mail și poți cere rambursarea în
            7 zile de la cumpărare, conform condițiilor de garanție.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-150" data-mp="3rigmotzeh2lh">
            Garanția nu îți afectează drepturile prevăzute de legislația privind protecția consumatorilor.
          </p>
        </div>
      </div>
    </section>;
}